import { z } from "zod";

export const validationSchema = z.object({
  phoneNumbers: z
    .string()
    .nonempty({ message: "Enter Phone Numbers to Scrub" }),
});
